const cardData = [
  {
    cardTitle: 'eCommerce info',
    cardDescription: 'These attributes allow you to track the commerce interests and activity of your visitors',
    hoverData: ['Cart update', 'Transaction', 'Viewed product'],
  },
  {
    cardTitle: 'Visitor info',
    cardDescription: 'Retrieve specific details about your website visitors, for example: the channel they arrive from and the affiliate they are associated with',
    hoverData: ['Customer info', 'Marketing source', 'Personal info'],
  },
  {
    cardTitle: 'Visitor Journey',
    cardDescription: 'Collect details about key actions that visitor take along their journey, and customize their experience accordingly. This include the leads they generated, errors they experience, and more',
    hoverData: ['Lead', 'Service activity', 'Visitor error', 'Searched content'],
  },
];

const sdeSectionData = [
  {
    cardTitle: 'eCommerce info',
    sections: [
      {
        sectionName: 'Cart Update',
        sectionDescription: 'Use the Cart Update attributes to get the status of the visitor’s shopping cart - the products within the cart, and its total monetary value.',
        prefix: 'sde.ecommerceinfo.cartupdate',
        unauth: true,
        auth: false,
      },
      {
        sectionName: 'Transaction',
        sectionDescription: 'Transaction, purchase/deposit details, including the products themselves and their details.',
        prefix: 'sde.ecommerceinfo.transaction',
        unauth: true,
        auth: false,
      },
      {
        sectionName: 'Viewed Product',
        sectionDescription: 'Use product viewed attributes to know more about which product categories interest your visitors.',
        prefix: 'sde.ecommerceinfo.viewedproduct',
        unauth: true,
        auth: false,
      },
    ],
  },
  {
    cardTitle: 'Visitor info',
    sections: [
      {
        sectionName: 'Customer Info',
        prefix: 'sde.visitorinfo.customerinfo',
        sectionDescription: 'Allows you to collect data about your registered visitors: the customer type, e.g. VIP or Platinum, and their life-cycle status, e.g. upgraded account or inactive.',
        unauth: false,
        auth: true,
      },
      {
        sectionName: 'Marketing Source',
        prefix: 'sde.visitorinfo.marketingsource',
        sectionDescription: 'Get more details about the source of your visitors, the campaign that drove them to your website, and the affiliate they are associated with.',
        unauth: true,
        auth: false,
      },
      {
        sectionName: 'Personal Info',
        prefix: 'sde.visitorinfo.personalinfo',
        sectionDescription: 'Allows you to collect personal information about visitors. You can pass login information from cookies or from questions you ask them in your forms.',
        unauth: false,
        auth: true,
      },
    ],
  },
  {
    cardTitle: 'Visitor Journey',
    sections: [
      {
        sectionName: 'Lead',
        prefix: 'sde.visitorjourney.lead',
        sectionDescription: 'Tracking lead information will help you understand what your visitors are interested in and where they are in your funnel. Tracking the value of the lead will appear in your revenue reports, in order for you to measure the monetary value of your campaigns.',
        unauth: true,
        auth: false,
      },
      {
        sectionName: 'Service Activity',
        prefix: 'sde.visitorjourney.serviceactivity',
        sectionDescription: 'Measuring service activities and success can be achieved by using this Engagement attribute. The data about ordering a checkbook, or software usage can be collected using the topic and status properties.',
        unauth: true,
        auth: false,
      },
      {
        sectionName: 'Visitor Error',
        prefix: 'sde.visitorjourney.visitorerror',
        sectionDescription: 'Getting the information about errors that visitors experience when they browse the site and fill out forms.',
        unauth: true,
        auth: false,
      },
      {
        sectionName: 'Searched Content',
        prefix: 'sde.visitorjourney.searchedcontent',
        sectionDescription: 'Getting information about content searched by visitors on the website. For example: searching for FAQs about how to reset password.',
        unauth: true,
        auth: false,
      },
    ],
  },
];

export { cardData, sdeSectionData };
